
































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import GeneralFeeSettings from '@/components/Products/ProductFees/General/GeneralFeeSettings.vue';
import TransactionalFees from '@/components/Products/ProductFees/Transactional/TransactionalFees.vue';
import ScheduledFees from '@/components/Products/ProductFees/Scheduled/ScheduledFees.vue';
import ManualFees from '@/components/Products/ProductFees/Manual/ManualFees.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import EntityType from '@/models/Shared/EntityType';

@Component({ name: 'ProductFees', components: { GeneralFeeSettings, ManualFees, ScheduledFees, TransactionalFees } })
export default class extends SaascadaVue {

    EntityType = EntityType;

	@Prop({required: true})
	entityType: EntityType;

    get generalFeeSettings() {
        if (this.entityType === EntityType.Product) {
			return ProductDetailsModule.product.generalFeeSettings;
		}
        return ProductIssueDetailsModule.productIssue.generalFeeSettings;
    }

}
